export const OUTLOOK_CATEGORY = 'Maximizer';

export interface ContactsSyncSettings {
  enabled: boolean;
  favoriteListKey?: string | null;
  favoriteListName?: string | null;
  outlookCategory?: string | null;
}

export interface TasksSyncSettings {
  enabled: boolean;
  outlookTodoListName?: string | null;
  outlookTodoListId?: string | null;
}

export interface AppointmentsSyncSettings {
  enabled: boolean;
  rollingWindowDaysBack?: number;
  rollingWindowDaysAfter?: number;
}

export interface EmailsSyncSettings {
  enabled: boolean;
  syncEverything: boolean;
}
